function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
const DescriptionGridDescription = /*#__PURE__*/React.memo(props => /*#__PURE__*/React.createElement(Box, _extends({
  __css: {
    fontWeight: 'bold',
    color: 'gray.9'
  }
}, props)));
DescriptionGridDescription.propTypes = {};
DescriptionGridDescription.defaultProps = {};
DescriptionGridDescription.displayName = 'DescriptionGridDescription';
export default DescriptionGridDescription;